import {defineMessages} from 'react-intl';

export default defineMessages({
	whattodonext: {
		id: 'returnInstructions.whattodonext',
		defaultMessage: 'What to do next?',
	},
	zeroStepTitle: {
		id: 'returnInstructions.zeroStepTitle',
		defaultMessage: 'How can i request a return?',
	},
	title1: {
		id: 'returnInstructions.title1',
		defaultMessage: '1. Request the return',
	},
	description1: {
		id: 'returnInstructions.description1',
		defaultMessage: 'Complete the steps above to start a return request',
	},
	title2: {
		id: 'returnInstructions.title2',
		defaultMessage: '2. Prepare the package',
	},
	description2: {
		id: 'returnInstructions.description2',
		defaultMessage: 'Place the documents listed in the "Return Instructions" section',
	},
	title3: {
		id: 'returnInstructions.title3',
		defaultMessage: '3. Attach the return label',
	},
	description3: {
		id: 'returnInstructions.description3',
		defaultMessage: 'You can find it in the original package. Not there? Check the "New Return Label" section',
	},
	title4: {
		id: 'returnInstructions.title4',
		defaultMessage: '4. Call the courier',
	},
	description4: {
		id: 'returnInstructions.description4',
		defaultMessage:
			'Contact the courier indicated on the return label ' +
			'in the ways noted in the "How to book a pickup?" section',
	},
	title5: {
		id: 'returnInstructions.title5',
		defaultMessage: '5. Shipping',
	},
	description5: {
		id: 'returnInstructions.description5',
		defaultMessage: 'Wait for courier to pickup or bring your package to the collection center',
	},
});
